export default __webpack_public_path__ + "static/media/ref1.349603cf.mp3";